module.exports = __webpack_public_path__ + "static/media/logo-cheffescolar-negativo.0f2fb5f4.svg";